"use client";
import ButtonSubmit from "@/components/FormSubmitButton";
import FormInput from "@/components/FormInput";
import apiAxios from "@/utils/api/apiAxios";
import Link from "next/link";
import React, { useState } from "react";
import { useRouter } from "next/navigation";
import { handleFormChange } from "@/utils/handleFormChange";
import { toast } from "sonner";
import FormInputPassword from "@/components/FormInputPassword";

const FormRegister = () => {
  const router = useRouter();
  const [formData, setFormData] = useState({
    complete_name: "",
    name: "",
    email: "",
    password: "",
    password_confirmation: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState({});

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    await apiAxios
      .post("/register", formData)
      .then((res) => {
        toast.success("Register Berhasil");
        router.push("/verifikasi?email=" + formData.email);
      })
      .catch((err) => {
        toast.error(err.message);
        setErrors(err.errors);
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };
  return (
    <form
      onSubmit={handleSubmit}
      className="flex flex-col md:grid grid-cols-2 gap-3"
    >
      <div className="col-span-2">
        <FormInput
          label={"Nama Lengkap"}
          name={"complete_name"}
          type={"text"}
          handleChange={(e) => handleFormChange(e, setFormData)}
          value={formData.complete_name}
          error={errors?.complete_name}
        />
      </div>
      <div>
        <FormInput
          label={"Nama Pengguna"}
          name={"name"}
          type={"text"}
          handleChange={(e) => handleFormChange(e, setFormData)}
          value={formData.name}
          error={errors?.name}
        />
      </div>
      <div>
        <FormInput
          label={"Email"}
          name={"email"}
          type={"email"}
          handleChange={(e) => handleFormChange(e, setFormData)}
          value={formData.email}
          error={errors?.email}
        />
      </div>
      <div>
        <FormInputPassword
          label={"Password"}
          name={"password"}
          handleChange={(e) => handleFormChange(e, setFormData)}
          value={formData.password}
          error={errors?.password}
        />
      </div>
      <div>
        <FormInputPassword
          label={"Konfirmasi Password"}
          name={"password_confirmation"}
          handleChange={(e) => handleFormChange(e, setFormData)}
          value={formData.password_confirmation}
          error={errors?.password_confirmation}
        />
      </div>

      <div className="col-span-2">
        <ButtonSubmit full={true} isSubmitting={isSubmitting}>
          Daftar
        </ButtonSubmit>
      </div>
      <div className="col-span-2">
        <p className="mt-2 text-sm font-light italic text-gray-500">
          Sudah memiliki akun?{" "}
          <Link href="/login" className="font-semibold  hover:text-slate-900">
            Login
          </Link>
        </p>
      </div>
    </form>
  );
};

export default FormRegister;
